import { areFieldsSet } from '@superbet-group/web.lib.utilities';

import { MessageBody } from '@store/modules/ui/inbox/types';

import { transformMessageStyle } from './transformMessageStyle';
import { transformPayloadMap } from './transformPayloadMap';
import { MessageBodyDto } from './dtos/InboxMessageDto';

export function transformMessageBody(dto: MessageBodyDto): MessageBody {
    return {
        id: dto.id,
        cid: dto.cid,
        title: dto.title,
        alert: dto.alert,
        icon: dto.icon,
        style: transformMessageStyle(dto.style),

        ...areFieldsSet(dto, 'payload_map') && { payloadMap: transformPayloadMap(dto.payload_map) },
        ...areFieldsSet(dto, 'url') && { url: dto.url },
        ...areFieldsSet(dto, 'url_blank') && { shouldOpenUrlInBlank: dto.url_blank },
        ...areFieldsSet(dto, 'url_mode') && { urlMode: dto.url_mode },
        ...areFieldsSet(dto, 'deeplink') && { deepLink: dto.deeplink },
    };
}
